import React, { useMemo } from 'react';

import { css, cx } from '@emotion/css';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { TelemonitoringTags } from '@/models/CarePlanModel.ts';
import {
  telemonitoringTagColorMapping,
  telemonitoringTagTranslationMapping,
} from '@/models/PatientSummaryModel.ts';
import { Tag } from '@/uiKit/atoms/Tag.tsx';

export type TelemonitoringActivityTagProps = {
  tags: TelemonitoringTags[] | undefined;
  format?: 'short' | 'long';
  className?: string;
};

export const TelemonitoringActivityTag: React.FC<
  TelemonitoringActivityTagProps
> = ({ tags = [], format = 'short', className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  const tag: TelemonitoringTags | undefined = useMemo(() => {
    if (tags.includes('active')) {
      return 'active';
    }
    if (tags.includes('expired')) {
      return 'expired';
    }
    return undefined;
  }, [tags]);

  if (!tag) {
    return null;
  }

  return (
    <Tag
      className={cx(styles.container, className)}
      label={t(telemonitoringTagTranslationMapping(tag), { context: format })}
      color={telemonitoringTagColorMapping(tag)}
      data-component="telemonitoring-activity-tag"
      data-options="active,expired"
      data-tag={tag}
      data-format={format}
    />
  );
};

const makeStyles = () => ({
  container: css({}),
});
